<template>
  <!-- 资讯发布页 -->
  <div class="form-content-container" style="overflow: hidden">
    <Form
      class="form-container"
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <FormItem
        ref="FormItemTitle"
        class="form-item"
        prop="curNum"
        :rules="[
          { required: true, message: '标题不能为空', trigger: 'change | blur' },
          { validator: validatetitle, trigger: 'change | blur' },
        ]"
      >
        <div class="title titleRichEditor">
          <!-- <Input
            class="titleInput"
            v-model="formValidate.curNum"
            :autosize="true"
            type="textarea"
            placeholder="请输入标题(5-50字)"
          /> -->
          <title-summary-editor
            v-if="titleFocus"
            bodyClass="chineseTitle"
            :id="'chineseTitle'"
            v-model.trim="formValidate.curNum"
            :initWithBold="true"
            initFontSize="36px"
            :minHeight="62"
            :placeholder="titlePlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="titleWordCount > 50 ? 'fontColor' : ''">{{
            titleWordCount
          }}</span>
          / 50
        </div>
      </FormItem>
      <FormItem class="form-item" prop="content" ref="FormItemContent">
        <Editor
          :id="'editor'"
          v-model="formValidate.content"
          :placeholder="'请输入正文'"
        />
      </FormItem>
      <FormItem class="form-item" prop="keyword" label="关键词">
        <Input
          placeholder="请输入关键词，多个关键词之间用英文逗号“,”隔开"
          v-model.trim="formValidate.keyword"
        />
      </FormItem>
      <FormItem class="form-item" label="作者" prop="author">
        <Input placeholder="请输入作者" v-model.trim="formValidate.author" />
      </FormItem>
      <FormItem
        ref="FormItemAbstract"
        class="form-item"
        label="摘要"
        prop="abstract"
        :rules="[{ validator: validateAbstract, trigger: 'change | blur' }]"
      >
        <div class="title abstract">
          <!-- <Input
            class="titleInput"
            v-model="formValidate.abstract"
            :autosize="true"
            type="textarea"
            placeholder="请输入摘要（摘要会在列表等区域外露，帮助用户快速了解内容，如不填写则默认抓取正文前200字用做展示）"
          
          /> -->
          <title-summary-editor
            bodyClass="englistTitle"
            :id="'chineseSummary'"
            v-model.trim="formValidate.abstract"
            :initWithBold="false"
            initFontSize="14px"
            :minHeight="62"
            :placeholder="summaryPlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="summaryWordCount > 500 ? 'fontColor' : ''">{{
            summaryWordCount
          }}</span>
          / 500
        </div>
      </FormItem>
      <FormItem class="form-item" label="封面">
        <RadioGroup v-model.trim="picture" @on-change="handleChange">
          <Radio label="无图"></Radio>
          <Radio label="单图"></Radio>
        </RadioGroup>
        <FormItem v-if="picture === '单图'" prop="cover" style="width: 100%">
          <PictureUpload
            :cover="formValidate.cover"
            @handleUpload="handleUpload"
          ></PictureUpload>
        </FormItem>
      </FormItem>
      <FormItem class="form-item" label="分类" prop="classification">
        <Select
          style="width: 200px"
          placeholder="请选择分类"
          v-model="formValidate.classification"
        >
          <Option :value="v.id" v-for="v in oneList" :key="v.id">{{
            v.name
          }}</Option>
        </Select>
      </FormItem>
      <FormItem class="form-item" label="是否原创" prop="isOriginal">
        <RadioGroup
          v-model.trim="formValidate.isOriginal"
          @on-change="handleChange1"
        >
          <Radio label="否" :value="1"></Radio>
          <Radio label="是" :value="0"></Radio>
        </RadioGroup>
        <FormItem v-if="isOrigin" prop="source" style="width: 100%">
          <Input placeholder="请输入来源" v-model.trim="formValidate.source" />
        </FormItem>
      </FormItem>
      <FormItem
        v-if="isOrigin"
        class="form-item"
        label="来源发布时间"
        prop="originalPublishTime"
      >
        <DatePicker
          style="width: 200px"
          type="date"
          placeholder="请选择时间"
          @on-change="formValidate.originalPublishTime = $event"
          :value="formValidate.originalPublishTime"
        >
        </DatePicker>
      </FormItem>
      <FormItem class="form-item" label="发布栏目">
        <!-- <CheckboxGroup v-model="columnNum">
          <Checkbox disabled :label="columnNum[0]"></Checkbox>
        </CheckboxGroup> -->
        <Tree
          :data="treeList"
          show-checkbox
          @on-check-change="changeCheck"
        ></Tree>
      </FormItem>
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          @click="handleSubmit(formValidate, 1)"
          :disabled="canClick"
          v-throttleClick="2000"
          >保存</Button
        >
        <Button
          @click="handleSubmit(formValidate, 0)"
          :disabled="canClick"
          v-throttleClick="2000"
          >发布</Button
        >
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import PictureUpload from "../../components/PictureUpload.vue";
import { mapState } from "vuex";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import Editor from "../../components/editor";
import ruleUtils from "@/utils/ruleValidate.js";
import TitleSummaryEditor from "@/views/PCView/user/components/TitleSummaryEditor";
export default {
  components: {
    PictureUpload,
    AuthenticationModel,
    Editor,
    TitleSummaryEditor,
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
    this.getListByType({
      type: 1,
    });
    this.projectAndColumnListByType({
      type: 1,
    });
    if (this.$route.query.id) {
      this.getEcho(this.formValidate);
      this.isShow = false;
    }
  },
  mounted() {
    this.titleFocus = true;
  },
  data() {
    return {
      titleFocus: false,
      canClick: false,
      titlePlaceHolder: "请输入标题(0~50)字",
      summaryPlaceHolder:
        "请输入摘要（摘要会在列表等区域外露，帮助用户快速了解内容，如不填写则默认抓取正文前200字用做展示）",
      titleWordCount: 0,
      summaryWordCount: 0,
      isFlag: false,
      tempArr: [],
      picture: "无图",
      treeList: [], //发布栏目
      isOrigin: true, // 是否原创
      ismodify: 1, // 不通过修改标识
      formValidate: {
        content: "",
        curNum: "",
        keyword: "",
        abstract: "",
        interest: [],
        isOriginal: "否",
        source: "",
        originalPublishTime: "",
        classification: "",
        cover: null,
        author: "",
      },
      ruleValidate: ruleUtils,
      oneList: [],
      isShow: true, // 预览按钮是否可点击
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 5,
        },
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "token"]),
    columnNum() {
      let arr = [];
      if (sessionStorage.getItem("isSon") === "false") {
        if (this.userInfo.user.customerType === 4) {
          arr = ["百科号"];
        } else if (this.userInfo.user.customerType === 5) {
          arr = ["机构号"];
        } else if (
          this.userInfo.user.customerType === 1 ||
          this.userInfo.user.customerType === 2
        ) {
          arr = ["百家号"];
        }
      } else {
        if (this.userInfo.user.subType === 1) {
          arr = ["百科号"];
        } else if (this.userInfo.user.subType === 2) {
          arr = ["机构号"];
        }
      }
      return arr;
    },
  },
  watch: {
    "formValidate.content"() {
      this.$refs.FormItemContent.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.curNum": {
      handler() {
        this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      },
      deep: true,
      // immediate: true,
    },
    "formValidate.abstract": {
      handler() {
        this.$refs.FormItemAbstract.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview({
        ...this.previewData.data,
      });
      let URL = this.$router.resolve({
        path: "/previewinformation",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    validatetitle(rule, value, callback) {
      var reg = new RegExp("<[^<>]+>", "g");
      var s = value.replace(reg, "");
      var reg2 = /\&[0-9a-z]+;/g;
      if (s.match(reg2) != null && s.match(reg2).length != 0) {
        s = s.replace(reg2, " ");
      }
      if (s.length < 5 || s.length > 50) {
        return callback(new Error("标题限制5到50个字数"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    validateAbstract(rule, value, callback) {
      var reg = new RegExp("<[^<>]+>", "g");
      var s = value.replace(reg, "");
      var reg2 = /\&[0-9a-z]+;/g;
      if (s.match(reg2) != null && s.match(reg2).length != 0) {
        s = s.replace(reg2, " ");
      }
      if (s.length > 500) {
        return callback(new Error("摘要限制500个字"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    getTitle(params) {
      /* params接收富文本对象，以JSON字符串方式传递，需解析为对象；
      解析后格式如{id: "englishTitle",value:{default: ""}} */
      params = JSON.parse(params);
      // 获取富文本输入框ID，用于区分
      var editorId = params.id;

      // params.value获取富文本输入框的值，有两种可能的值，默认为对象类型 value:{default: ""}；一旦有值，则变为字符串类型，如value: '<p style="line-height: 1.5;">&nbsp;'
      let originalText = params.value; // 获取富文本输入框原始值
      if (typeof originalText == "object") originalText = "";

      // 定义正则表达式reg 过滤标签（无法正常保留<>,如遇<某某决议>这种，还需修改正则）
      var reg = new RegExp("<[^<>]+>", "g");
      // 过滤后的字符串内容，用于统计字数
      let countText = originalText.replace(reg, "");

      // 现将特殊字符$nbsp;替换成空格然后将其他特殊字符匹配成1来便于计数
      var reg2 = /\&[0-9a-z]+;/g;
      countText = countText.replace(/&nbsp;/gi, "");
      if (countText.match(reg2) != null && countText.match(reg2).length != 0) {
        countText = countText.replace(reg2, "1");
      }
      // 将原值中的额$nbsp;替换为普通空格(html中的空格)
      originalText = originalText.replace(/&nbsp;/gi, "");

      // 不为空时，保留sub,sup标签，过滤其他标签
      originalText = originalText.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
      originalText = originalText.trim();
      // 去掉头尾空格以计数
      countText = countText.trim();

      if (editorId == "chineseTitle") {
        this.formValidate.curNum = originalText;
        countText = this.filterSubSup(countText);
        this.titleWordCount = countText.length;
        this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      } else if (editorId == "chineseSummary") {
        this.formValidate.abstract = originalText;
        countText = this.filterSubSup(countText);
        this.summaryWordCount = countText.length;
        this.$refs.FormItemAbstract.$emit("on-form-change");
      }
    },
    // 过滤字符串中的sub/sup标签，返回过滤后的字符串。以计字数
    filterSubSup(s) {
      if (s.indexOf("<sub>") != -1 || s.indexOf("<sup>") != -1) {
        s = s.replace(/<sub>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
        s = s.replace(/<sup>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
      }
      return s;
    },
    // 分类
    async getListByType(data) {
      const resp = await this.$apis.userServe.listByType(data);
      this.oneList = resp.data.filter((item) => item.status == 1);
    },
    getTrees() {
      this.treeList = this.treeList.map((item) => {
        return {
          title: item.projectName,
          expand: true,
          menuIds: item.projectId,
          checked: false,
          children:
            item.columns &&
            item.columns.map((v) => {
              return {
                title: v.columnName,
                menuIds: item.projectId,
                id: v.id,
                checked: false,
              };
            }),
        };
      });
    },
    // 回显
    async getEcho(f) {
      const resp = await this.$apis.userServe.getDetailsByUser({
        articleId: this.$route.query.id,
        articleType: 5,
      });
      // this.projectAndColumnListByType({
      //   type: 1,
      // });
      // 发布栏目
      resp.data.articlePushList.forEach((itemL) => {
        this.treeList.forEach((itemT) => {
          if (
            itemT.children &&
            itemT.children.length > 0 &&
            itemL.projectId !== undefined
          ) {
            itemT.children.forEach((itemC) => {
              if (itemC.id == itemL.channelId1) {
                itemC["checked"] = true;
              }
            });
          } else {
            if (itemT.id == itemL.channelId1) {
              itemT["checked"] = true;
            }
          }
        });
      });
      const r = resp.data.data;
      f.curNum = r.title;
      f.keyword = r.keyword;
      f.abstract = r.artSummary;
      f.content = r.content;
      f.cover = r.cover;
      f.author = r.author;
      this.picture = r.cover ? "单图" : "无图";
      f.isOriginal = r.originalType === 1 ? "否" : "是";
      f.source = r.source;
      f.originalPublishTime = r.originalPublishTime;
      f.classification = this.oneList.some(
        (item) => item.id == r.classification
      )
        ? +r.classification
        : ""; // 分类
      if (f.isOriginal === "是") {
        f.source = "";
        this.isOrigin = false;
      }
      this.ismodify = r.auditStatus;
    },
    handleUpload(url) {
      this.formValidate.cover = url; // 图片路径
    },
    changeCheck(item) {
      this.tempArr = item;
    },
    handleChange(e) {
      if (e === "无图") this.formValidate.cover = null; //如果是无图，就删除
    },
    handleChange1(e) {
      if (e === "否") {
        this.isOrigin = true;
      } else {
        this.isOrigin = false;
      }
    },
    async projectAndColumnListByType(data) {
      const resp = await this.$apis.userServe.projectAndColumnListByType(data);
      this.treeList.push(resp.data[0]);
      this.getTrees();
    },
    // 表单提交按钮
    async handleSubmit(formValidate, status) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          if (this.tempArr.length === 0) {
            this.treeList.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((v) => {
                  if (v.checked) {
                    this.tempArr.push(v);
                  }
                });
              } else {
                if (item.checked) {
                  this.tempArr.push(item);
                }
              }
            });
          }
          // 发布栏目
          let arr = [];
          this.tempArr.forEach((item) => {
            if (!(item.children && item.children.length > 0)) {
              arr.push({
                projectId: item.menuIds || null,
                channelId1: item.id || null,
              });
            } else {
              return;
            }
          });
          formValidate.interest = [...arr];

          const { data } = await this.$apis.userServe.webSave({
            auditStatus: status === 1 ? 1 : this.ismodify === 2 ? 2 : 0, // this.ismodify === 2 已发布修改, status 1是保存 2是发布
            articleType: 5,
            title: formValidate.curNum,
            author: formValidate.author,
            content: formValidate.content,
            keyword: formValidate.keyword,
            artSummary:
              formValidate.abstract === "" ? null : this.formValidate.abstract,
            originalType: formValidate.isOriginal === "否" ? 1 : 0,
            articlePushList: formValidate.interest,
            source: formValidate.source,
            cover: formValidate.cover,
            originalPublishTime: formValidate.originalPublishTime,
            articleId:
              this.$route.query.id || this.previewData.data.articleId || null,
            classification: formValidate.classification,
          });
          if (data.resultCode === "200") {
            this.isShow = false;
            this.$Message.success(status === 1 ? "保存成功" : "发布成功");
            this.previewData = data;
            this.canClick = false;
            if (status === 1) return;
            this.$router.push("/user/messageMrg");
          } else {
            this.canClick = false;
            this.$Message.error(data.resultDesc);
          }
        } else {
          this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    clearField() {
      this.formValidate.content = "";
      this.formValidate.curNum = "";
      this.formValidate.keyword = "";
      this.formValidate.abstract = "";
      this.formValidate.source = "";
      this.formValidate.isOriginal = "否";
      this.formValidate.originalPublishTime = "";
      this.picture = "无图";
      this.tempArr = [];
      this.formValidate.classification = "";
    },
  },
};
</script>

<style lang="scss" scoped>
#text-container ::v-deep table {
  th,
  td {
    width: 200px;
    height: 35px;
    vertical-align: top;
    word-break: break-all;
  }
}
#text-container ::v-deep .placeholder {
  color: #999;
}
#text-container ::v-deep .w-e-text-container {
  z-index: 1 !important;
}
#toolbar-container ::v-deep .w-e-toolbar {
  justify-content: center;
  z-index: 2 !important;
}
#text-container {
  width: 100%;
  min-height: 300px;
  border: none;
  outline: none;
  padding: 4px 7px;
  color: #515a6e;
}
::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li {
  display: flex;
  margin: 0;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}
.fontColor {
  color: red !important;
}
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 80px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
      // align-items: center;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      height: 100%;
      line-height: 38px;
      position: relative;
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }
      &::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    .abstract {
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 14px;
          resize: none;
        }
      }
    }
    .left,
    .right {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .plus {
        width: 30px;
        height: 30px;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        font-size: 2em;
      }
    }
    .left {
      border-right: 1px solid #dcdcdc;
      width: 355px;
    }
    .right {
      margin-left: 10px;
      width: 642px;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
    }
    .year {
      width: 299px;
      border-right: 1px solid #dcdcdc;
    }
    .center {
      width: 323px;
      border-right: 1px solid #dcdcdc;
    }
    .stage {
      width: 374px;
    }
    label {
      white-space: nowrap;
      margin-right: 20px;
    }
  }
  .title-item {
    align-items: end;
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
